module.exports = __webpack_public_path__ + "img/market-moni-logo-01.8036bd7f.png";